import { render, staticRenderFns } from "./DocumentsViewerItem.vue?vue&type=template&id=7b3771e8&"
import script from "./DocumentsViewerItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsViewerItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsViewerItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports